export default __webpack_public_path__ + "static/media/KeyBiscayne.05e420a6.jpg";